import { c as _c } from "react/compiler-runtime";
// Twemoji is used for emoji rendering
// https://twemoji.twitter.com
import React, { CSSProperties } from 'react';
import { buildClassNames } from '../../style/build-class-names';
import { ParsedCountry } from '../../types';
import './flag-emoji.module.css';
const incrementCodepoint = (codePoint: string, incrementBy: number): string => {
  const decimal = parseInt(codePoint, 16);
  return Number(decimal + incrementBy).toString(16);
};
const alphabet = 'abcdefghijklmnopqrstuvwxyz';
const A_LETTER_CODEPOINT = '1f1e6';
const codepoints: Record<string, string> = alphabet.split('').reduce((obj, currentLetter, index) => {
  return {
    ...obj,
    // construct alphabet by incrementing A letter codepoint value
    [currentLetter]: incrementCodepoint(A_LETTER_CODEPOINT, index)
  };
}, {});

/**
 * Flag emoji value contains 2 emojis which represents iso2 code
 * For example: '🇺🇦' -> U+1F1FA (U letter), U+1F1E6 (A letter)
 * For Twemoji we need to pass codepoints in format `1f1fa-1f1e6`
 */
const getFlagCodepointByIso2 = (iso2: ParsedCountry['iso2']) => {
  const char0 = iso2?.[0] ? codepoints[iso2[0]] : '';
  const char1 = iso2?.[1] ? codepoints[iso2[1]] : '';
  return [char0, char1].filter(Boolean).join('-');
};
interface FlagEmojiProps extends React.HTMLAttributes<HTMLImageElement> {
  iso2?: ParsedCountry['iso2'];
  size?: CSSProperties['width'];
  protocol?: 'http' | 'https';
  disableLazyLoading?: boolean;
}
export const FlagEmoji: React.FC<FlagEmojiProps> = t0 => {
  const $ = _c(21);
  let className;
  let disableLazyLoading;
  let iso2;
  let restProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      iso2,
      size: t1,
      protocol: t2,
      disableLazyLoading,
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disableLazyLoading;
    $[3] = iso2;
    $[4] = restProps;
    $[5] = t1;
    $[6] = t2;
  } else {
    className = $[1];
    disableLazyLoading = $[2];
    iso2 = $[3];
    restProps = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const size = t1 === undefined ? "24px" : t1;
  const protocol = t2 === undefined ? "https" : t2;
  if (!iso2) {
    let t3;
    if ($[7] !== restProps || $[8] !== size) {
      t3 = <img width={size} height={size} {...restProps} />;
      $[7] = restProps;
      $[8] = size;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t3;
  if ($[10] !== iso2) {
    t3 = getFlagCodepointByIso2(iso2);
    $[10] = iso2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const flagCodepoint = t3;
  const src = `${protocol}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${flagCodepoint}.svg`;
  let t4;
  if ($[12] !== className) {
    t4 = buildClassNames({
      addPrefix: ["flag-emoji"],
      rawClassNames: [className]
    });
    $[12] = className;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = disableLazyLoading ? undefined : "lazy";
  let t6;
  if ($[14] !== iso2 || $[15] !== restProps || $[16] !== size || $[17] !== src || $[18] !== t4 || $[19] !== t5) {
    t6 = <img className={t4} src={src} width={size} height={size} draggable={false} data-country={iso2} loading={t5} {...restProps} />;
    $[14] = iso2;
    $[15] = restProps;
    $[16] = size;
    $[17] = src;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};